import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  type TemplateRef,
} from '@angular/core';
import { PreventScrollDirective } from '@bizzdesign/shared/directives';
@Component({
  selector: 'bd-drawer',
  imports: [NgClass, NgTemplateOutlet, PreventScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss',
})
export class DrawerComponent {
  @Input() template: TemplateRef<any> | null = null;

  @Input() size: 'small' | 'regular' = 'regular';
}
